// The only way the rest of the app reaches the 3D Otto: a dynamic import, so
// three.js and the model load only in video mode (design 7.5) and, on the
// check-in page, only after the owner first touches the form (design 3.4 step 1).
import type { ModelVariant } from "./models";

export const loadOttoAvatar = () => import("./OttoAvatar");

let preloading: ModelVariant | null = null;

/**
 * Start the 3D download early. Best effort by design: if it fails, the call
 * page shows the 2D Otto and loads the 3D Otto again itself, so a failure here
 * is logged, not shown.
 */
export function preloadAvatar(variant: ModelVariant): void {
  if (preloading === variant) return;
  preloading = variant;
  loadOttoAvatar()
    .then((module) => module.preloadOttoModel(variant))
    .catch((error: unknown) => {
      preloading = null;
      console.warn("[otto] 3D preload failed; the call will retry", error);
    });
}

export function avatarPreloadStarted(): boolean {
  return preloading !== null;
}
